export const SET_PROPERTY_INVOICE = "SET_PROPERTY_INVOICE";
export const INVOICES_RECEIVED = "INVOICES_RECEIVED";
export const CLEAR_INVOICES = "CLEAR_INVOICES";
export const CREATE_INVOICE = "CREATE_INVOICE";
export const SET_INVOICE = "SET_INVOICE";